// extracted by mini-css-extract-plugin
module.exports = {"resizeBarStyle":"style_resizeBarStyle__56jDQ","isDragging":"style_isDragging__pkX2A"};